/**
 * Home Page — sections & items
 * Future: fetched from Supabase `pages` + `sections` + `section_items`
 */

const homePage = {
  seo: {
    title: "Bijoux en résine personnalisés",
    description: "Sublime Résine — Créations artisanales de bijoux en résine personnalisés pour immortaliser vos compagnons à quatre pattes. Fait main au Québec. Colliers, boucles d'oreilles, médailles, porte-clés et plus.",
    path: "/",
  },
  sections: [
    {
      id: "home_hero",
      type: "hero",
      isActive: true,
      sortOrder: 1,
      data: {
        badge: { icon: "sparkles", text: "Fait à la main au Québec" },
        title: "Des bijoux en résine",
        titleAccent: "uniques et personnalisés",
        subtitle: "Immortalisez vos compagnons à quatre pattes avec nos créations artisanales. Chaque pièce est unique, fabriquée avec amour et soin.",
        image: "/images/hero-main.jpg",
        imageAlt: "Bijoux en résine artisanaux Sublime Résine",
        floatingBadge: { title: "100% personnalisable", subtitle: "Couleurs, brillants, détails" },
        cta1: { label: "Voir les collections", href: "/bijoux" },
        cta2: { label: "Comment ça marche", href: "/comment-ca-marche" },
      },
    },
    {
      id: "home_collections",
      type: "collection_grid",
      isActive: true,
      sortOrder: 2,
      data: {
        title: "Nos collections",
        subtitle: "Découvrez toutes nos créations en résine, personnalisables selon vos envies.",
        cta: { label: "Voir toutes les collections", href: "/bijoux" },
      },
      // items: pulled from collections data automatically
    },
    {
      id: "home_steps",
      type: "steps",
      isActive: true,
      sortOrder: 3,
      data: {
        title: "Comment ça marche",
        subtitle: "En quatre étapes simples, recevez votre bijou personnalisé.",
        cta: { label: "En savoir plus", href: "/comment-ca-marche" },
      },
      items: [
        { id: "home_step_1", icon: "palette", title: "Choisissez", desc: "Parcourez nos collections et sélectionnez le bijou qui vous plaît.", isActive: true, sortOrder: 1 },
        { id: "home_step_2", icon: "messageCircle", title: "Personnalisez", desc: "Indiquez vos préférences : couleurs, brillants, détails du design.", isActive: true, sortOrder: 2 },
        { id: "home_step_3", icon: "package", title: "Commandez", desc: "Remplissez le formulaire avec vos choix et envoyez-nous vos photos ou poils.", isActive: true, sortOrder: 3 },
        { id: "home_step_4", icon: "heart", title: "Recevez", desc: "Votre création unique est fabriquée à la main et livrée chez vous.", isActive: true, sortOrder: 4 },
      ],
    },
    {
      id: "home_personalization",
      type: "personalization",
      isActive: true,
      sortOrder: 4,
      data: {
        title: "Votre bijou, à votre image",
        text: "Toutes les créations sont personnalisables selon vos envies : couleurs, brillants, éléments intégrés et détails du design.",
        image: "https://images.pexels.com/photos/4741620/pexels-photo-4741620.jpeg?auto=compress&cs=tinysrgb&w=600",
        imageAlt: "Bijou en résine personnalisé",
      },
      // supplements: pulled from siteSettings automatically
    },
    {
      id: "home_cta",
      type: "cta_banner",
      isActive: true,
      sortOrder: 5,
      data: {
        title: "Prêt à créer votre bijou unique ?",
        subtitle: "Remplissez notre formulaire de commande et nous vous contacterons pour finaliser votre création personnalisée.",
        cta: { label: "Commander maintenant", href: "/commander" },
      },
    },
    {
      id: "home_faq",
      type: "faq",
      isActive: true,
      sortOrder: 6,
      data: {
        title: "Questions fréquentes",
        subtitle: "Tout ce que vous devez savoir sur nos créations.",
      },
      items: [
        { id: "faq_1", question: "Comment sont fabriqués les bijoux en résine ?", answer: "Chaque bijou est fabriqué artisanalement à la main au Québec. Nous utilisons de la résine de haute qualité dans laquelle nous intégrons vos éléments personnels (photos, poils, brillants, couleurs) pour créer une pièce unique et durable.", isActive: true, sortOrder: 1 },
        { id: "faq_2", question: "Combien de temps prend la fabrication d'une commande ?", answer: "Le délai de fabrication est généralement de 2 à 3 semaines, selon la complexité de votre commande et le volume de demandes en cours. Nous vous tiendrons informé de l'avancement.", isActive: true, sortOrder: 2 },
        { id: "faq_3", question: "Comment envoyer les poils de mon animal ?", answer: "Après votre commande, nous vous enverrons les instructions détaillées pour l'envoi des poils par la poste. Une petite quantité suffit — environ une pincée de poils propres et secs dans une enveloppe.", isActive: true, sortOrder: 3 },
        { id: "faq_4", question: "Puis-je personnaliser entièrement mon bijou ?", answer: "Absolument ! Toutes nos créations sont personnalisables : couleurs de résine, ajout de brillants, paillettes, fleurs séchées, et bien sûr les photos ou poils de votre compagnon. Contactez-nous pour discuter de vos idées.", isActive: true, sortOrder: 4 },
        { id: "faq_5", question: "Quels sont les frais de livraison ?", answer: "La livraison par Poste Canada est de 5 $. Nous livrons partout au Canada. Les commandes sont soigneusement emballées pour protéger vos bijoux durant le transport.", isActive: true, sortOrder: 5 },
        { id: "faq_6", question: "Acceptez-vous les retours ou échanges ?", answer: "Étant donné que chaque bijou est une création sur mesure et personnalisée, nous n'acceptons pas les retours. Cependant, si votre bijou arrive endommagé, contactez-nous immédiatement et nous trouverons une solution.", isActive: true, sortOrder: 6 },
      ],
    },
  ],
};

export default homePage;
